import { Link } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type Props = { slug?: string; reason?: string };

export default function Gone({ slug, reason }: Props) {
    const reasonLabel = reason === 'tag-retired'
        ? 'Tag pages were retired during the 2026 site rebuild.'
        : reason === 'category-retired'
            ? 'The category index for that slug no longer exists.'
            : 'That page was permanently removed.';

    return (
        <PublicLayout>
            <section className="max-w-2xl mx-auto px-6 py-24 text-center">
                <div className="text-[12px] uppercase tracking-widest text-ember mb-3">
                    Gone · 410
                </div>
                <h1 className="text-[44px] leading-tight text-ink">
                    This page is no longer here.
                </h1>
                <p className="text-ink-soft mt-3">{reasonLabel}</p>
                {slug && (
                    <p className="text-[14px] text-ink-soft mt-2">
                        Reference: <code className="bg-paper px-1 rounded">/{slug}</code>
                    </p>
                )}
                <div className="mt-8 flex justify-center gap-3">
                    <Link href="/">
                        <Btn size="lg">Back to home</Btn>
                    </Link>
                    <Link href="/search">
                        <Btn size="lg" kind="secondary">Find a lawyer</Btn>
                    </Link>
                </div>
            </section>
        </PublicLayout>
    );
}
